/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'calendar-time': {
    width: 19,
    height: 18,
    viewBox: '0 0 19 18',
    data: '<path pid="0" d="M9.8 18c-4.963 0-9-4.037-9-9 0-2.37.96-4.689 2.636-6.364a.72.72 0 111.018 1.018A7.616 7.616 0 002.24 9c0 4.169 3.391 7.56 7.56 7.56S17.36 13.17 17.36 9c0-3.926-3.007-7.163-6.84-7.525V5.04a.72.72 0 01-1.44 0V.72A.72.72 0 019.8 0c4.963 0 9 4.037 9 9s-4.037 9-9 9zM5.69 5.91A.72.72 0 116.71 4.89l4.109 3.091a1.44 1.44 0 01-2.036 2.036L5.691 5.91z" _fill="#213F6B" fill-rule="evenodd"/>'
  }
})
